import request from '@/system/engine/request';
import config from '@/system/engine/config';
import {getLocalStorage} from '@/system/store/localstorage';

export function roiAjaxTable(limit,pagination,id,created_at,master_id,total_value,is_pay,login){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'bonus/roi/ajaxTable?language='+language+'&limit=' + limit  + '&pagination=' + pagination  + '&id=' + id  + '&created_at=' + created_at  + '&master_id=' + master_id  + '&total_value=' + total_value + '&is_pay=' + is_pay + '&login=' + login,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function sponsormatchingAjaxTable(limit,pagination,id,created_at,master_id,total_value,is_pay){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'bonus/sponsormatching/ajaxTable?language='+language+'&limit=' + limit  + '&pagination=' + pagination  + '&id=' + id  + '&created_at=' + created_at  + '&master_id=' + master_id  + '&total_value=' + total_value  + '&is_pay=' + is_pay,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function sponsorshareAjaxTable(limit,pagination,id,created_at,master_id,total_value,is_pay){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'bonus/sponsorshare/ajaxTable?language='+language+'&limit=' + limit  + '&pagination=' + pagination  + '&id=' + id  + '&created_at=' + created_at  + '&master_id=' + master_id  + '&total_value=' + total_value  + '&is_pay=' + is_pay,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function rankbonusAjaxTable(limit,pagination,id,created_at,master_id,total_value,is_pay){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'bonus/rankbonus/ajaxTable?language='+language+'&limit=' + limit  + '&pagination=' + pagination  + '&id=' + id  + '&created_at=' + created_at  + '&master_id=' + master_id  + '&total_value=' + total_value  + '&is_pay=' + is_pay,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function rankoverridingbonusAjaxTable(limit,pagination,id,created_at,master_id,total_value,is_pay){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'bonus/rankoverridingbonus/ajaxTable?language='+language+'&limit=' + limit  + '&pagination=' + pagination  + '&id=' + id  + '&created_at=' + created_at  + '&master_id=' + master_id  + '&total_value=' + total_value  + '&is_pay=' + is_pay,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function ranklevelmatchingbonusAjaxTable(limit,pagination,id,created_at,master_id,total_value,is_pay){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'bonus/ranklevelmatchingbonus/ajaxTable?language='+language+'&limit=' + limit  + '&pagination=' + pagination  + '&id=' + id  + '&created_at=' + created_at  + '&master_id=' + master_id  + '&total_value=' + total_value  + '&is_pay=' + is_pay,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function toprankbonusAjaxTable(limit,pagination,id,created_at,master_id,total_value,is_pay){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'bonus/toprankbonus/ajaxTable?language='+language+'&limit=' + limit  + '&pagination=' + pagination  + '&id=' + id  + '&created_at=' + created_at  + '&master_id=' + master_id  + '&total_value=' + total_value  + '&is_pay=' + is_pay,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function badgebonusAjaxTable(limit,pagination,id,created_at,master_id,total_value,is_pay){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'bonus/badgebonus/ajaxTable?language='+language+'&limit=' + limit  + '&pagination=' + pagination  + '&id=' + id  + '&created_at=' + created_at  + '&master_id=' + master_id  + '&total_value=' + total_value  + '&is_pay=' + is_pay,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function badgebonusglobalAjaxTable(limit,pagination,id,created_at,master_id,total_value,is_pay){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'bonus/badgebonusglobal/ajaxTable?language='+language+'&limit=' + limit  + '&pagination=' + pagination  + '&id=' + id  + '&created_at=' + created_at  + '&master_id=' + master_id  + '&total_value=' + total_value  + '&is_pay=' + is_pay,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function badgebonusreleaseAjaxTable(limit,pagination,id,created_at,master_id,total_value,is_pay){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'bonus/badgebonusrelease/ajaxTable?language='+language+'&limit=' + limit  + '&pagination=' + pagination  + '&id=' + id  + '&created_at=' + created_at  + '&master_id=' + master_id  + '&total_value=' + total_value  + '&is_pay=' + is_pay,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function migrateGroupAjaxTable(limit,pagination,id,created_at,master_id,total_value,is_pay){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'bonus/migrategroup/ajaxTable?language='+language+'&limit=' + limit  + '&pagination=' + pagination  + '&id=' + id  + '&created_at=' + created_at  + '&master_id=' + master_id  + '&total_value=' + total_value  + '&is_pay=' + is_pay,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function migratePersonalAjaxTable(limit,pagination,id,created_at,master_id,total_value,is_pay){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'bonus/migratepersonal/ajaxTable?language='+language+'&limit=' + limit  + '&pagination=' + pagination  + '&id=' + id  + '&created_at=' + created_at  + '&master_id=' + master_id  + '&total_value=' + total_value  + '&is_pay=' + is_pay,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function bonusInfo(limit,pagination,master_id,created_at,bonus_code){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'bonus/info/ajaxTable?language='+language+'&limit=' + limit  + '&pagination=' + pagination  + '&master_id=' + master_id  + '&created_at=' + created_at  + '&bonus_code=' + bonus_code,
		method: 'get'
	});

	return Promise.resolve(data);
}